import {
  FAVORITE_WATCHLIST,
  useRemoteStorage,
  WHATS_NEW_SELECTED_WATCHLISTS,
} from '@terminal/hooks/use-remote-storage';
import { useFeedFilters } from '@terminal/stores/use-feed-filters/useFeedFilters';

import { Watchlist } from './watchlist-types';

export const getValidWatchlistIds = (lists: Watchlist[]) =>
  new Set(lists.map(list => list.id));

export const reconcileWatchlistLinkedStorage = async (
  validIds: Set<string>
) => {
  const { items, storeItems, deleteItem } = useRemoteStorage.getState();
  const { selectedWatchlistIds, setSelectedWatchlistIds } =
    useFeedFilters.getState();

  const favoriteId = items?.[FAVORITE_WATCHLIST];

  if (
    typeof favoriteId === 'string' &&
    favoriteId.length > 0 &&
    !validIds.has(favoriteId)
  ) {
    await deleteItem(FAVORITE_WATCHLIST);
  }

  // Insight-feed watchlist selection is updated via `setSelectedWatchlistIds`, which persists to
  // WHATS_NEW_SELECTED_WATCHLISTS.
  const nextInsightFeedSelection = new Set(
    [...selectedWatchlistIds].filter(id => validIds.has(id))
  );

  if (nextInsightFeedSelection.size !== selectedWatchlistIds.size) {
    setSelectedWatchlistIds(nextInsightFeedSelection);
  }

  const whatsNew = items?.[WHATS_NEW_SELECTED_WATCHLISTS] ?? [];
  const nextWhatsNew = whatsNew.filter(item => validIds.has(item.id));

  if (nextWhatsNew.length !== whatsNew.length) {
    await storeItems({ [WHATS_NEW_SELECTED_WATCHLISTS]: nextWhatsNew });
  }
};
